<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-12">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a>Fire Foresight</a>
      </li>
      
      <li class="breadcrumb-item">
        <a>Admin</a>
      </li>
    </ol>
  </div>
</div>

<div class="modal fade" bsModal #addItemModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">ADD STATUS</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="addItemModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Display Name</label>
              <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newStatus.displayName" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Description</label>
              <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newStatus.description" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Colour</label>
              <div class="input-group m-b">
                  <div [style.background-color]="newStatus.colour" style="width: 30px; height: 30px; border-radius: 50%; display: inline-block; border: 1px solid #ddd; margin-right: 10px; vertical-align: middle;"></div>
                  <input type="color" [(ngModel)]="newStatus.colour" class="form-control" style="width: 60px; padding: 2px;"/>
                  <input type="text" [(ngModel)]="newStatus.colour" class="form-control" placeholder="#RRGGBB"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Visible</label>
              <div class="input-group m-b">
                  <input type="checkbox" [(ngModel)]="newStatus.visible" class="form-control"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="addItemModal.hide()" class="btn btn-white">Cancel</button>
        <button (click)="saveNewItem();addItemModal.hide()" class="btn btn-white">Add</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #updateItemModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">UPDATE STATUS</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="updateItemModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group input-group-sm">
              <label>Status ID</label>
              <div class="input-group m-b">
                  <span class="pt-2">{{editStatus.statusId}}</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group input-group-sm">
              <label>Display Name</label>
              <div class="input-group m-b">
                  <input type="text" [(ngModel)]="editStatus.displayName" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group input-group-sm">
              <label>Description</label>
              <div class="input-group m-b">
                  <input type="text" [(ngModel)]="editStatus.description" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group input-group-sm">
              <label>Colour</label>
              <div class="input-group m-b">
                  <div [style.background-color]="editStatus.colour" style="width: 30px; height: 30px; border-radius: 50%; display: inline-block; border: 1px solid #ddd; margin-right: 10px; vertical-align: middle;"></div>
                  <input type="color" [(ngModel)]="editStatus.colour" class="form-control" style="width: 60px; padding: 2px;"/>
                  <input type="text" [(ngModel)]="editStatus.colour" class="form-control" placeholder="#RRGGBB"/>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group input-group-sm">
              <label>Visible</label>
              <div class="input-group m-b">
                  <input type="checkbox" [(ngModel)]="editStatus.visible" class="form-control-checkbox"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="updateItemModal.hide()" class="btn btn-white">Cancel</button>
        <button (click)="updateStatus(editStatus);updateItemModal.hide()" class="btn btn-white">Save</button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" bsModal #addResponsiblePartyModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">ADD RESPONSIBLE PARTY</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="addResponsiblePartyModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Display Name <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                  <input type="text" 
                         [(ngModel)]="newResponsibleParty.displayName" 
                         (blur)="markNewRPFieldTouched('displayName')"
                         class="form-control" 
                         [class.is-valid]="newRPTouched.displayName && newResponsibleParty.displayName"
                         [class.is-invalid]="newRPTouched.displayName && !newResponsibleParty.displayName"
                         required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Description <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                  <input type="text" 
                         [(ngModel)]="newResponsibleParty.description" 
                         (blur)="markNewRPFieldTouched('description')"
                         class="form-control" 
                         [class.is-valid]="newRPTouched.description && newResponsibleParty.description"
                         [class.is-invalid]="newRPTouched.description && !newResponsibleParty.description"
                         required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Colour <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                  <input type="color" 
                         [(ngModel)]="newResponsibleParty.colour" 
                         (blur)="markNewRPFieldTouched('colour')"
                         class="form-control" 
                         [class.is-valid]="newRPTouched.colour && newResponsibleParty.colour"
                         [class.is-invalid]="newRPTouched.colour && !newResponsibleParty.colour"
                         style="width: 20px; padding: 2px; height:35px" 
                         required/>
                  <input type="text" 
                         [(ngModel)]="newResponsibleParty.colour" 
                         (blur)="markNewRPFieldTouched('colour')"
                         class="form-control" 
                         [class.is-valid]="newRPTouched.colour && newResponsibleParty.colour"
                         [class.is-invalid]="newRPTouched.colour && !newResponsibleParty.colour"
                         placeholder="#RRGGBB" 
                         required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Customer</label>
              <div class="input-group m-b">
                  <select [(ngModel)]="newResponsibleParty.customerId" (ngModelChange)="onNewCustomerChange()" class="form-control">
                    <option [ngValue]="null">-- Select Customer (Optional) --</option>
                    <option *ngFor="let customer of app.customers" [ngValue]="customer.customerId">{{customer.customerName}}</option>
                  </select>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group input-group-sm">
              <label>Distribution List</label>
              <div class="input-group m-b" *ngIf="newResponsibleParty.customerId && newDistributionLists.length > 0">
                  <select [(ngModel)]="newResponsibleParty.distributionListId" class="form-control">
                    <option [ngValue]="null">-- Select Distribution List (Optional) --</option>
                    <option *ngFor="let list of newDistributionLists" [ngValue]="list.distributionListId">{{list.listName}}</option>
                  </select>
              </div>
              <div class="input-group m-b" *ngIf="!newResponsibleParty.customerId || newDistributionLists.length === 0">
                  <input type="number" [(ngModel)]="newResponsibleParty.distributionListId" class="form-control" placeholder="Enter ID or select customer first"/>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group input-group-sm">
              <label>Distribution Template</label>
              <div class="input-group m-b" *ngIf="newResponsibleParty.customerId && newMessageTemplates.length > 0">
                  <select [(ngModel)]="newResponsibleParty.distributionTemplateId" class="form-control">
                    <option [ngValue]="null">-- Select Template (Optional) --</option>
                    <option *ngFor="let template of newMessageTemplates" [ngValue]="template.messageTemplateId">{{template.templateName}}</option>
                  </select>
              </div>
              <div class="input-group m-b" *ngIf="!newResponsibleParty.customerId || newMessageTemplates.length === 0">
                  <input type="number" [(ngModel)]="newResponsibleParty.distributionTemplateId" class="form-control" placeholder="Enter ID or select customer first"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Visible</label>
              <div class="input-group m-b">
                <input type="checkbox" [(ngModel)]="newResponsibleParty.visible" class="form-control-checkbox"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="addResponsiblePartyModal.hide()" class="btn btn-white">Cancel</button>
        <button (click)="saveNewResponsibleParty();addResponsiblePartyModal.hide()" 
                class="btn btn-white" 
                [disabled]="!isNewResponsiblePartyValid()">Add</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #updateResponsiblePartyModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">UPDATE RESPONSIBLE PARTY</h5> <span class="pt-2">{{editResponsibleParty.responsiblePartyId}}</span>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="updateResponsiblePartyModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Display Name <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                  <input type="text" 
                         [(ngModel)]="editResponsibleParty.displayName" 
                         (blur)="markEditRPFieldTouched('displayName')"
                         class="form-control" 
                         [class.is-valid]="editRPTouched.displayName && editResponsibleParty.displayName"
                         [class.is-invalid]="editRPTouched.displayName && !editResponsibleParty.displayName"
                         required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Description <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                  <input type="text" 
                         [(ngModel)]="editResponsibleParty.description" 
                         (blur)="markEditRPFieldTouched('description')"
                         class="form-control" 
                         [class.is-valid]="editRPTouched.description && editResponsibleParty.description"
                         [class.is-invalid]="editRPTouched.description && !editResponsibleParty.description"
                         required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Colour <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <div class="input-group flex-nowrap">
                <input type="color" 
                         [(ngModel)]="editResponsibleParty.colour" 
                         (blur)="markEditRPFieldTouched('colour')"
                         class="form-control" 
                         [class.is-valid]="editRPTouched.colour && editResponsibleParty.colour"
                         [class.is-invalid]="editRPTouched.colour && !editResponsibleParty.colour"
                         style="width: 20px; padding: 2px; height:35px" 
                         required/>
                  <input type="text" 
                         [(ngModel)]="editResponsibleParty.colour" 
                         (blur)="markEditRPFieldTouched('colour')"
                         class="form-control" 
                         [class.is-valid]="editRPTouched.colour && editResponsibleParty.colour"
                         [class.is-invalid]="editRPTouched.colour && !editResponsibleParty.colour"
                         placeholder="#RRGGBB" 
                         required/>
                  </div>  
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Customer</label>
              <div class="input-group m-b">
                  <select [(ngModel)]="editResponsibleParty.customerId" (ngModelChange)="onEditCustomerChange()" class="form-control">
                    <option [ngValue]="null">-- Select Customer (Optional) --</option>
                    <option *ngFor="let customer of this.app.customers" [ngValue]="customer.customerId">{{customer.customerName}}</option>
                  </select>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Distribution List</label>
              <div class="input-group m-b" *ngIf="editResponsibleParty.customerId && editDistributionLists.length > 0">
                  <select [(ngModel)]="editResponsibleParty.distributionListId" class="form-control">
                    <option [ngValue]="null">-- Select Distribution List (Optional) --</option>
                    <option *ngFor="let list of editDistributionLists" [ngValue]="list.distributionListId">{{list.listName}}</option>
                  </select>
              </div>
              <div class="input-group m-b" *ngIf="!editResponsibleParty.customerId || editDistributionLists.length === 0">
                  <input type="number" [(ngModel)]="editResponsibleParty.distributionListId" class="form-control" placeholder="Enter ID or select customer first"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Distribution Template</label>
              <div class="input-group m-b" *ngIf="editResponsibleParty.customerId && editMessageTemplates.length > 0">
                  <select [(ngModel)]="editResponsibleParty.distributionTemplateId" class="form-control">
                    <option [ngValue]="null">-- Select Template (Optional) --</option>
                    <option *ngFor="let template of editMessageTemplates" [ngValue]="template.messageTemplateId">{{template.templateName}}</option>
                  </select>
              </div>
              <div class="input-group m-b" *ngIf="!editResponsibleParty.customerId || editMessageTemplates.length === 0">
                  <input type="number" [(ngModel)]="editResponsibleParty.distributionTemplateId" class="form-control" placeholder="Enter ID or select customer first"/>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group input-group-sm">
              <label>Visible</label>
              <div class="input-group m-b">
                  <input type="checkbox" [(ngModel)]="editResponsibleParty.visible" class="form-control-checkbox"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="updateResponsiblePartyModal.hide()" class="btn btn-white">Cancel</button>
        <button (click)="updateResponsibleParty(editResponsibleParty);updateResponsiblePartyModal.hide()" 
                class="btn btn-white" 
                [disabled]="!isEditResponsiblePartyValid()">Save</button>
      </div>
    </div>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight" id="status">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-2 bg-emphasis bg-opacity-25">
        <div class="card-body">
          <tabset>
            <tab heading="Statuses">
              <div class="d-flex align-items-center fw-400 mt-2 mb-2">
                <span class="flex-grow-1"></span>
                <button (click)="addItemModal.show()" class="btn btn-outline-default">Add Status</button>
              </div>
              <table class="table table-striped"> 
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Display Name</th>
                    <th scope="col">Description</th>
                    <th scope="col">Colour</th>
                    <th scope="col">Visible</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of list">
                    <td>{{item.statusId}}</td>
                    <td>{{item.displayName}}</td>
                    <td>{{item.description}}</td>
                    <td>
                      <div [style.background-color]="item.colour" style="width: 20px; height: 20px; border-radius: 50%; display: inline-block;"></div>
                    </td>
                    <td>
                      <i *ngIf="item.visible" class="fa fa-check"></i>
                    </td>
                    <td>
                      <!-- edit template -->
                      <a (click)="editStatus=item;updateItemModal.show()" class="btn btn-outline-default"><i class="fa fa-pencil"></i></a>
                      <!-- delete -->
                      &nbsp;
                      <a (click)="removeStatus(item)" class="btn btn-outline-danger ml-2"><i class="fa fa-trash"></i></a>
                    </td>
                    <td>
                      <!-- <button class="btn btn-outline-default" [routerLink]="'/site-type/' + list.siteTypeId">Open</button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </tab>

            <tab heading="Responsible Parties">
              <div class="d-flex align-items-center fw-400 mt-2 mb-2">
                <span class="flex-grow-1"></span>
                <button (click)="addResponsibleParty();addResponsiblePartyModal.show()" class="btn btn-outline-default">Add Responsible Party</button>
              </div>
              <table class="table table-striped"> 
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Display Name</th>
                    <th scope="col">Description</th>
                    <th scope="col">Colour</th>
                    <th scope="col">Visible</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of responsibleParties">
                    <td>{{item.responsiblePartyId}}</td>
                    <td>{{item.displayName}}</td>
                    <td>{{item.description}}</td>
                    <td>
                      <div [style.background-color]="item.colour" style="width: 20px; height: 20px; border-radius: 50%; display: inline-block;"></div>
                    </td>
                    <td>
                      <i *ngIf="item.visible" class="fa fa-check"></i>
                    </td>
                    <td>
                      <!-- edit template -->
                      <a (click)="openEditResponsiblePartyModal(item);updateResponsiblePartyModal.show()" class="btn btn-outline-default"><i class="fa fa-pencil"></i></a>
                      <!-- delete -->
                      &nbsp;
                      <a (click)="removeResponsibleParty(item)" class="btn btn-outline-danger ml-2"><i class="fa fa-trash"></i></a>
                    </td>
                    <td>
                      <!-- <button class="btn btn-outline-default" [routerLink]="'/site-type/' + list.siteTypeId">Open</button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </tab>

            <tab heading="Camera Configs">
              <app-fire-foresight-camera-configs [embedded]="true"></app-fire-foresight-camera-configs>
            </tab>

            <tab heading="Sites">
              <app-fire-foresight-sites [embedded]="true"></app-fire-foresight-sites>
            </tab>
          </tabset>
        </div>
      </div>
    </div>
  </div>
</div>